import { custom, failure, success } from "./utilities";
import { countriesEncyclopediaService } from "../../services";
import {
  globalConstants,
  countriesEcncylopediaConstants,
} from "../../constants";
import { customToast } from "../../shared/utility";
import { ERROR_TOAST } from "../../constants/toast.constants";

const {
  ALL_COUNTRIES_ENCYCLOPEDIA,
  COUNTRIES_ENCYCLOPEDIA_PAGINATION,
  GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID,
} = countriesEcncylopediaConstants;

// Fetch a list of countries for the encyclopedia
const getAllCountriesEncyclopedia = (payload) => {
  return (dispatch) => {
    dispatch(
      custom(ALL_COUNTRIES_ENCYCLOPEDIA, globalConstants.SPINNER_ACTIVATE)
    );
    countriesEncyclopediaService
      .getAllCountriesEncyclopedia(payload)
      .then(
        (response) => {
          dispatch(success(response.data, ALL_COUNTRIES_ENCYCLOPEDIA));
        },
        (error) => {
          customToast(error[0], ERROR_TOAST);
          dispatch(failure([], ALL_COUNTRIES_ENCYCLOPEDIA));
        }
      )
      .finally(() =>
        dispatch(
          custom(ALL_COUNTRIES_ENCYCLOPEDIA, globalConstants.SPINNER_DIACTIVATE)
        )
      );
  };
};

// Fetch detailed information about a specific country
const getCountryEncyclopediaDetailById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID,
        globalConstants.SPINNER_ACTIVATE
      )
    );
    countriesEncyclopediaService
      .getCountryEncyclopediaDetailById(id)
      .then(
        (response) => {
          dispatch(
            success(response.data, GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID)
          );
        },
        (error) => {
          customToast(error[0], ERROR_TOAST);
          dispatch(failure({}, GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID));
        }
      )
      .finally(() =>
        dispatch(
          custom(
            GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID,
            globalConstants.SPINNER_DIACTIVATE
          )
        )
      );
  };
};

const updatePagination = (data) => (dispatch) =>
  dispatch(custom(data, COUNTRIES_ENCYCLOPEDIA_PAGINATION));

export const countriesEncyclopediaActions = {
  updatePagination,
  getAllCountriesEncyclopedia,
  getCountryEncyclopediaDetailById,
};
